import { AuthModel, PageAccess, PermissionSectionModel } from '../api/model/model';
import { Page, Role } from 'features/shared/model';
import jwtDecode from 'jwt-decode';
import { isEnumKey } from 'utils/enums';

const AUTH_LOCAL_STORAGE_KEY = 'advance-kt-auth-react-v';
const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return;
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY);
  if (!lsValue) {
    return;
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel;
    if (auth) {
      // You can easily check auth_token expiration also
      return auth;
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error);
  }
};

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return;
  }

  try {
    const lsValue = JSON.stringify(auth);
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue);
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error);
  }
};

const removeAuth = () => {
  if (!localStorage) {
    return;
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY);
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error);
  }
};

export const adminOnly = [Role.Administrator];

function getAuthRole(): Role | null {
  const authCred = getAuth();

  if (authCred && authCred.token) {
    return getRoleFromToken(authCred.token);
  }
  return null;
}

function getRoleFromToken(apiToken: string) {
  const decodedToken: any = jwtDecode(apiToken);
  const role = decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
  return isEnumKey(Role, role) ? Role[role] : null;
}

function hasAccess(_allowedRoles: Role[], _userRole: Role | undefined | null) {
  if (_userRole) {
    return Boolean(_allowedRoles?.find((aRole) => _userRole == aRole));
  }
  return false;
}

function getUserPermissions(userPermissions: PermissionSectionModel[]): PageAccess[] {
  const permissions: PageAccess[] = [];
  userPermissions.forEach((p: PermissionSectionModel) => {
    const page = p.id as Page;
    p.permissionRoles?.forEach((a) => {
      permissions.push({
        page,
        access: {
          create: a.create ?? false,
          read: a.read ?? false,
          update: a.update ?? false,
          delete: a.delete ?? false
        }
      });
    });
  });
  return permissions;
}

export {
  getAuth,
  setAuth,
  removeAuth,
  AUTH_LOCAL_STORAGE_KEY,
  hasAccess,
  getAuthRole,
  getRoleFromToken,
  getUserPermissions
};
